import styled from 'styled-components';
import { media } from '@minecraft.themes';
import Button from '@minecraft.button';
import Icon from '@minecraft.icon';

export const BasicInfoContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  ${media.sm`
    flex-direction: row;
  `}
`;

export const PrimaryPhotoContainer = styled.div`
  max-width: 100%;
  padding-right: 3rem;
  img {
    max-width: 100%;
  }
  ${media.sm`
    max-width: 31.125rem;
    width: 100%;
    padding-right: 3rem;
  `}
`;

export const ProfileInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

export const ProfilePhotoLabel = styled.div`
  font-size: 0.85rem;
  font-weight: bold;
`;

export const ProfilePhotoContainer = styled.div`
  max-width: 100%;
  position: relative;
`;

export const ProfileBirthday = styled.div`
  position: absolute;
  right: 0.25rem;
  bottom: 0.25rem;
  background-color: rgba(0, 0, 0, 0.2);
  padding: 0.25rem 0.25rem 0;
  border-radius: 0.25rem;
  color: ${(props): string => props.theme.colors.primary.white};
  svg {
    vertical-align: baseline;
    margin-right: 0.25rem;
  }
`;

export const ButtonContainer = styled.div`
  background: ${(props): string => props.theme.colors.accent.greyBlue2};
  padding: 1rem;
  margin: 1rem 0;
  &:first-child {
    margin-top: 1.6rem;
  }
`;

export const StyledButton = styled(Button)`
  width: 100%;
  ${media.sm`
    width:auto;
  `};
`;

export const MediaContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-top: 0;
  flex-direction: column;
  ${media.sm`
    margin-top: 2rem;
    flex-direction: row;
    align-items: flex-start;
  `};
  & button {
    height: max-content;
  }
`;

export const VideoMediaContainer = styled.div`
  margin-bottom: 3.125rem;
  width: 10rem;
  word-break: break-all;
`;

export const AudioMediaContainer = styled.div`
  margin-bottom: 1.875rem;
  width: 10rem;
  word-break: break-all;
  ${media.sm`
    margin-left: 3rem;
  `}
`;

export const VideoMediaButtonContainer = styled.div`
  margin: 0 auto;
  justify-content: center;
  ${media.sm`
    justify-content: flex-start;
    margin:0 0 0 3rem;
  `}
`;

export const StyledUserInfo = styled.div`
  border-bottom: 0.0625rem solid ${(props): string => props.theme.colors.primary.ltGrey1};
  padding-bottom: 0.7rem;
  line-height: 1.2rem;
  padding-top: 0.7rem;
  &:first-child {
    margin-top: 0.7rem;
  }
`;

export const InfoRow = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const InfoDesc = styled.p`
  margin: 0;
`;

export const InfoHead = styled.h4`
  margin: 0 0 0.5rem;
  font-weight: 600;
  font-size: 1rem;
`;

export const ElementRelative = styled.div`
  position: relative;
  width: fit-content;
`;

export const CustomModal = styled.div`
  margin-top: -2.25rem;
  h2 {
    font-size: 1.125rem;
    margin-bottom: 0.9375rem;
    word-break: break-word;
  }
  h1 {
    font-size: 1.5rem;
    margin-bottom: 0.5rem;
  }
  > div {
    padding-left: 0;
    padding-right: 0;
    border: 0;
    > div {
      margin-bottom: 1.5rem;
    }
  }
`;

export const StyledIcon = styled(Icon)`
  position: absolute;
  width: 3rem;
  height: 3rem;
  top: 50%;
  left: 50%;
  transform: translateY(-50%) translateX(-50%);
`;
